/** True when `target` is an element inside (or equal to) an element with `className` — the v11 opt-out classes. */
export const isInsideClass = (target: EventTarget | null, className: string): boolean =>
  target instanceof Element && target.closest(`.${className}`) !== null;

/** Elements with this class do not start a pan or a double-click zoom (v11 `noPanClassName`). */
export const NO_PAN_CLASS = 'nopan';

/** Elements with this class never start a node drag (v11 `noDragClassName`). */
export const NO_DRAG_CLASS = 'nodrag';

/** Elements with this class keep the wheel for themselves (v11 `noWheelClassName`). */
export const NO_WHEEL_CLASS = 'nowheel';
